import xhr from '../../Xhr';

const API = (id, out_order_no) => ({
  goods: {
    url: process.env.REACT_APP_API + `/v1/user/${id}/product`,
    method: 'GET'
  },
  qrCode: {
    url: process.env.REACT_APP_API + `/v1/user/${id}/product/2prepay`,
    method: 'POST'
  },
  payResult: {
    url: process.env.REACT_APP_API + `/v1/user/${id}/product/paystate?transaction_sn=${out_order_no}`,
    method: 'GET'
  }
})

const checkAPI = (id, code) => ({
  checkCode: {
    url: process.env.REACT_APP_API + `/v1/user/${id}/couponcode?code=${code}`,
    method: 'GET'
  }
})

export const fetchGoods = () => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).goods,
    action: 'GOODS/INFO'
  })
}

export const fetchQRCode = ({data, ...event}) => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid')).qrCode,
    action: 'GOODS/QRCODE',
    data,
    event
  })
}

export const checkCode = ({code, ...event}) => {
  return xhr({
    api: checkAPI(localStorage.getItem('ShadowFog_userid'), code).checkCode,
    action: 'GOODS/PAYRESULT',
    event
  })
}

export const fetchPayResult = ({out_order_no, ...event}) => {
  return xhr({
    api: API(localStorage.getItem('ShadowFog_userid'), out_order_no).payResult,
    action: 'GOODS/PAYRESULT',
    event
  })
}

export const showModal = () => ({
  type: 'SHOW_MODAL'
})

export const hideModal = () => ({
  type: 'HIDE_MODAL'
})


// WEBPACK FOOTER //
// ./src/modules/goods/actions.js